import { render, staticRenderFns } from "./ChecklistSeguridadSaludRuta.vue?vue&type=template&id=0fed6792&"
import script from "./ChecklistSeguridadSaludRuta.vue?vue&type=script&lang=js&"
export * from "./ChecklistSeguridadSaludRuta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports